import {
  CLEAR_ATA_PROPS,
  CREATE_ASSET_TRANSFER_ADVICE_SUCCESS,
  FETCH_ASSET_TRANSFER_ADVICE_SUCCESS,
  FETCH_ASSETS_BY_QUERY_SUCCESS,
  FETCH_ATA_NO_SUCCESS,
  FETCH_METER_UNIT_SUCCESS,
  GET_ASSET_TRANSFER_ADVICE_SUCCESS,
  GET_ATA_COUNT_START,
  GET_ATA_COUNT_SUCCESS,
  SAVE_ASSET_TRANSFER_ADVICE_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  assetListByClientAndLocation: [],
  ataNo: 0,
  meterUnit: [],
  allMeterUnit:[],
  ataCount: 0,
  ataAssetCount: 0,
  ataCountLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ASSET_TRANSFER_ADVICE_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_ASSET_TRANSFER_ADVICE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_ASSET_TRANSFER_ADVICE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_ASSET_TRANSFER_ADVICE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case FETCH_ASSETS_BY_QUERY_SUCCESS: {
      return {
        ...state,
        assetListByClientAndLocation: action.data,
      };
    }

    case FETCH_ATA_NO_SUCCESS: {
      return {
        ...state,
        ataNo: action.data,
      };
    }

    case FETCH_METER_UNIT_SUCCESS: {
      return {
        ...state,
        meterUnit: action.data,
      }
    }

    case CLEAR_ATA_PROPS: {
      return {
        ...state,
        edit: {},
      }
    }

    case GET_ATA_COUNT_SUCCESS: {
      return {
        ...state,
        ataCount: action.count,
        ataAssetCount: action.totalAssets,
        ataCountLoading: false
      }
    }
    case GET_ATA_COUNT_START: {
      return {
        ...state,
        ataCountLoading: true
      };
    }

    default:
      return state;
  }
}
